import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { ApiService } from './api.service';
import { IParent, IParentListFilter, IParentListResponse, IParentListSort, IParentSingleResponse } from '../../state/models/parent.model';
@Injectable({
  providedIn: 'root'
})
export class ParentService {

  private readonly apiUrl = `${environment.parentEndpoint}/api/parent-client`;

  constructor( private readonly apiService: ApiService) { }

  // List Parents
  getParents(
    page: number = 1,
    limit: number = 100,
    filter?: IParentListFilter,
    sort?: IParentListSort
  ): Promise<IParentListResponse> {
    return this.apiService.post<IParentListResponse>(
      `${this.apiUrl}/list?page=${page}&limit=${limit}`,
      { filter, sort }
    );
  }

  // Add this method
  getParent(id: string): Promise<IParentSingleResponse> {
    return this.apiService.get<IParentSingleResponse>(`${this.apiUrl}/${id}`);
  }

  createParent(parent: Omit<IParent, 'id'>): Promise<IParentSingleResponse> {
    return this.apiService.post<IParentSingleResponse>(`${this.apiUrl}/`, parent);
  }

  updateParent(id: string, parent: Partial<IParent>): Promise<IParentSingleResponse> {
    return this.apiService.put<IParentSingleResponse>(`${this.apiUrl}/${id}`, parent);
  }

  deleteParent(id: string): Promise<IParentSingleResponse> {
    return this.apiService.delete<IParentSingleResponse>(`${this.apiUrl}/${id}`);
  }

  changeParentStatus(id: string): Promise<IParentSingleResponse> {
    return this.apiService.patch<IParentSingleResponse>(`${this.apiUrl}/${id}`, {});
  }
}
